import * as React from "react";

import { Button, Grid, Modal, TextInput, Title } from "@mantine/core";
import {
  addViaEdge,
  BaseEdgeDataType,
  BaseNodeDataType,
  createNode,
  workflowActionTypes,
  workflowStateType,
} from "../WorkflowUtils";
import { IDispatchAction } from "src/types";
import { UAction, UNodeType, UseCaseType } from "@supportinitiative/common";
import { UseCaseCVMContext } from "../../UseCaseCVMContext";
import { showNotification } from "@mantine/notifications";
import { getId, getIsStringMatch } from "../../../utilities";
import { UseFieldArrayReturn } from "react-hook-form";

export default function AddViaEdge({
  name,
  edge,
  workflowDispatch,
  nodes,
  edges,
  actions,
  reconsArray,
  options,
  fromOrchestrator = false,
}: {
  name: string;
  edge: BaseEdgeDataType | null;
  workflowDispatch: React.Dispatch<IDispatchAction<workflowActionTypes, workflowStateType>>;
  nodes: BaseNodeDataType[];
  edges: BaseEdgeDataType[];
  actions: UAction[];
  options: { label: string; name: string; icon: React.ReactNode }[];
  fromOrchestrator?: boolean;
  reconsArray?: UseFieldArrayReturn<UseCaseType, "definition.recons", "key">;
}) {
  const { state: useCaseFormState } = React.useContext(UseCaseCVMContext);

  let [filteredOptions, setFilteredOptions] = React.useState(options);

  return (
    <Modal
      centered
      size={"xl"}
      opened={true}
      onClose={() => {
        workflowDispatch({
          type: "RESET",
          value: {
            action: null,
            via: null,
          },
        });
      }}
      title={<Title order={3}>Add</Title>}
    >
      <Grid align="stretch" gutter={"xs"} mb="xs">
        <Grid.Col span={12}>
          <TextInput
            placeholder="Filter"
            onChange={(event) => {
              if (event.target.value) {
                let values = options.filter(getIsStringMatch(event.target.value));
                setFilteredOptions(values);
              } else {
                setFilteredOptions(options);
              }
            }}
          />
        </Grid.Col>
      </Grid>

      <Grid align="center" gutter={"xs"} mt="lg" mb="xs">
        {filteredOptions.map((option) => {
          return (
            <Grid.Col span={3} key={option.name}>
              <Button
                leftSection={option.icon}
                fullWidth
                variant="default"
                onClick={() => {
                  const newNode = createNode(getId(), option.name as UNodeType, option.name);
                  // console.log(edge, newNode);
                  if (edge) {
                    const newWorkflow = addViaEdge(newNode, edge, nodes, edges, actions);
                    // console.log("newWorkflow", newWorkflow);

                    if (fromOrchestrator) {
                      if (
                        newNode.data?.type.toUpperCase() === "MONITORING" ||
                        newNode.data?.type.toUpperCase() === "RECONCILIATION"
                      ) {
                        const action = newWorkflow.actions.find((act) => act.id === newNode.id);

                        if (action) {
                          reconsArray ? reconsArray.append(action) : null;
                          useCaseFormState.setValue(name, newWorkflow);
                        } else {
                          showNotification({
                            id: "error",
                            title: "New node",
                            message: "Unable to add new reconciliation/monitoring flow",
                            color: "red",
                          });
                        }
                      } else {
                        useCaseFormState.setValue(name, newWorkflow);
                      }
                    } else {
                      // console.log(name, newWorkflow);
                      useCaseFormState.setValue(name, newWorkflow);
                    }

                    workflowDispatch({
                      type: "RESET",
                      value: {
                        action: null,
                        via: null,
                      },
                    });
                  }
                }}
              >
                {option.label}
              </Button>
            </Grid.Col>
          );
        })}
      </Grid>
    </Modal>
  );
}
